import React from 'react'
import { fetchApplication } from 'careers/actions/application'
import FetchWithSpinner from 'components/fetch-with-spinner'
import JobAdQuickInterview from 'careers/pages/job-ad-quick-interview'

interface ContinueApplicationProps {
  params: {
    token: string
  }
}

function ContinueApplication(props: ContinueApplicationProps) {
  return (
    <FetchWithSpinner action={() => fetchApplication(props.params)}>
      <JobAdQuickInterview {...props} />
    </FetchWithSpinner>
  )
}

export default ContinueApplication
